import { render, staticRenderFns } from "./CommodityCostAdjustListFunc.vue?vue&type=template&id=3cb986a1&scoped=true"
import script from "./CommodityCostAdjustListFunc.vue?vue&type=script&lang=js"
export * from "./CommodityCostAdjustListFunc.vue?vue&type=script&lang=js"
import style0 from "./CommodityCostAdjustListFunc.vue?vue&type=style&index=0&id=3cb986a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb986a1",
  null
  
)

export default component.exports